import { render, staticRenderFns } from "./AdminItem.vue?vue&type=template&id=7f97641b&scoped=true&"
import script from "./js/admin-item.js?vue&type=script&lang=js&"
export * from "./js/admin-item.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f97641b",
  null
  
)

export default component.exports